module.exports = __webpack_public_path__ + "static/media/05-i-am-that-i-am.feec07bb.mp3";